export default {
    /****** String helper *******
     * @function getTimerSplit
     ****************************/
    getTimerSplit: function(timer) {
        var timeSPlitObj = {
            day: "0",
            hour: "0",
            minute: "0",
            second: "0",
        }
        if (timer.displayTime != ''){
            let arrTime = timer.displayTime.split(":");

            timeSPlitObj.day = arrTime[arrTime.length - 4] ? arrTime[arrTime.length - 4] : "0";
            timeSPlitObj.hour = arrTime[arrTime.length - 3] ? arrTime[arrTime.length - 3] : "0";
            timeSPlitObj.minute = arrTime[arrTime.length - 2] ? arrTime[arrTime.length - 2] : "0";
            timeSPlitObj.second = arrTime[arrTime.length - 1] ? arrTime[arrTime.length - 1] : "0";

            return timeSPlitObj;
        } else {
            return timeSPlitObj;
        }
    },
}
